import { render, staticRenderFns } from "./WQtypeBigtextView.vue?vue&type=template&id=a4992674&"
import script from "./WQtypeBigtextView.vue?vue&type=script&lang=ts&"
export * from "./WQtypeBigtextView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports